// frontend/src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, PhoneAuthProvider } from "firebase/auth";

// Configuration with Hardcoded API Key to prevent "invalid-api-key" error
const firebaseConfig = {
  apiKey: "AIzaSyCsPiqDt3lTXeKR1HWeIcaAbg6EIXpycHE", 
  authDomain: "everything-automotive-83b06.firebaseapp.com",
  projectId: "everything-automotive-83b06",
  storageBucket: "everything-automotive-83b06.firebasestorage.app",
  messagingSenderId: "1044309685922",
  appId: "1:1044309685922:web:7520dc07e8bda0b963c8e9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth
const auth = getAuth(app);

// Providers
const googleProvider = new GoogleAuthProvider();
const phoneProvider = new PhoneAuthProvider(auth);

export { auth, googleProvider, phoneProvider };